import React, { useState, useEffect } from "react";
import { apiFetch } from "../../api/api"; // Aapka existing API utility

const ArrowRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" className="ml-2">
    <path d="M4 12h16M13 5l7 7-7 7" />
  </svg>
);

const ClientSuccessSection = () => {
  const [meta, setMeta] = useState({ heading: "", description: "" });
  const [stories, setStories] = useState([]);

  useEffect(() => {
    apiFetch("/home/clientstories.php?type=meta", { auth: false })
      .then((res) => setMeta(res.data || {}))
      .catch((err) => console.error("Error loading meta:", err));

    apiFetch("/home/clientstories.php", { auth: false })
      .then((res) => setStories(res.data || []))
      .catch((err) => console.error("Error loading stories:", err));
  }, []);

  // Index ke hisab se exact links set karne ka function (Fix applied for index 1)
  const getStoryLink = (index) => {
    if (index === 0) {
      return "/photobook";      // Pehli photo (Photobook)
    } else if (index === 1) {
      return "/notebooks";      // Doosri photo (Notebooks)
    } else if (index === 2) {
      return "/gift-hampers";    // Teesri photo (Gift Hamper)
    } else {
      return "/notebooks";
    }
  };

  return (
    <section className="py-8 xs:py-10 sm:py-16 md:py-24 px-4 xs:px-5 sm:px-6 md:px-12 lg:px-20 bg-white">
      <div className="max-w-[1400px] mx-auto flex flex-col items-center justify-center">
        
        <div className="w-full grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 justify-items-center">
          {stories.map((story, index) => (
            <div key={story.id || index} className="flex flex-col group cursor-pointer h-full w-full max-w-[380px] bg-white">
              <div className="overflow-hidden rounded-[10px] sm:rounded-[16px] mb-2.5 sm:mb-5 shadow-sm group-hover:shadow-md">
                <img
                  src={story.image_url} 
                  alt={story.title}
                  loading="lazy"
                  className="w-full h-[180px] xs:h-[160px] sm:h-[220px] md:h-[240px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <h3 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }}
                className="text-[#1A1A1A] text-[16px] sm:text-[22px] font-medium leading-snug mb-3 sm:mb-4 line-clamp-2"
              >
                {story.title}
              </h3>
              <div className="mt-auto">
                <a href={getStoryLink(index)}
                  className="block w-full text-center border border-gray-300 text-[#1A1A1A] py-2.5 sm:py-2 text-[12px] font-medium hover:bg-[#F9F9F9] rounded-sm transition-colors"
                >
                  View Story
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ClientSuccessSection;